
<div class="report-sidebar">
  <div class="header d-flex w-100 align-items-center py-2 px-4">
    <a :href="`/dashboard/template_builder?type=${reportTemplate.type}`" @click.prevent="handleNavigation">
      <v-icon dense color="#3F3F3F" size="24">mdi-arrow-left</v-icon>
    </a>
    <div>
      <template v-if="!isEditingName">
        <template v-if="isTruncated">
          <v-tooltip bottom max-width="280px">
            <template v-slot:activator="{ on, attrs }">
              <h3 ref="reportTitle" class="ma-0 font-bold" v-bind="attrs" v-on="on" style="width: 250px;">
                {{ truncate(reportTemplate.name || '') }}
              </h3>
            </template>
            <span>{{ reportTemplate.name }}</span>
          </v-tooltip>
        </template>
        <h3 v-else class="ma-0 font-bold" style="width: 250px;">{{ reportTemplate.name }}</h3>
      </template>
      <input v-else v-model.trim="newName" ref="nameInput" class="form-control" type="text" style="width: 250px;" />
      <h6 class="ma-0 mt-2">{{ mappedType }}</h6>
    </div>
    <button v-if="reportTemplate.name !== 'Quick'" class="btn btn-small btn-outline-secondary"
      style="padding: 0 6px 2px 6px; margin-left: auto;" @click="toggleEdit">
      <v-icon small dense color="#3F3F3F">
        <template v-if="isEditingName">mdi-content-save</template>
        <template v-else>mdi-pencil-outline</template>
      </v-icon>
    </button>
  </div>

  <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-4 h-100">
    <v-progress-circular color="primary" indeterminate></v-progress-circular>
  </div>

  <template v-else>
    <div v-if="!isHideSearch" class="py-4 px-6">
      <!-- Filer & Search -->
      <div class="filter-search">
        <div class="position-relative bg-white w-100">
          <v-icon small class="bg-white position-absolute p-2" style="right: 0.5rem; top: 4px;"
            color="rgba(79, 79, 79, 1)">mdi-magnify</v-icon>
          <CInput placeholder="Search Column by Title" type="text" v-model="search" @input="fetchFilteredColumns">
          </CInput>
        </div>
        <p class="ma-0 mt-2">{{ infoText }}</p>
      </div>
    </div>
    <div v-if="!isHideSearch" class="category-list">
      <div class="px-6 d-flex flex-wrap" style="gap: 8px;">
        <button :class="[
          'btn',
          'btn-sm',
          activeCategory === 'all' ? 'btn-primary' : 'btn-outline-secondary'
        ]" @click="setActiveCategory('all')">
          All
        </button>
        <button v-for="category in columnList" :key="category.key" :class="[
          'btn',
          'btn-sm',
          category.key === activeCategory ? 'btn-primary' : 'btn-outline-secondary'
        ]" @click="setActiveCategory(category.key)">
          {{ category.name }}
        </button>
      </div>
    </div>
    <!-- Column List -->
    <ColumnList />
  </template>

</div>
